import { styled } from '@mui/material/styles';
import RadioGroup from '@mui/material/RadioGroup';

export const RadioGroupStyled = styled(RadioGroup)(() => ({
  'label:first-child': {
    marginRight: '45px',
    span: {
      marginRight: '5px'
    }
  }
}));

export const Box = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: '15px -3px 15px 10px',
  color: theme.color.grey[800],
  '@media (max-width: 907px)': {
    alignItems: 'start',
    flexDirection: 'column'
  }
}));

export const Text = styled('div')(() => ({
  width: '600px'
}));

